import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEOHeadingNormalizer from './components/SEOHeadingNormalizer';
import RouteSEO from './components/RouteSEO';
import Home from './pages/Home';
import About from './pages/About';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Imprint from './components/Imprint';
import AiLeadAgent from './pages/AiLeadAgent';
import BeautyClinicOffer from './pages/BeautyClinicOffer';
import ContentShootingOffer from './pages/ContentShootingOffer';
import CaseStudiesOverview from './pages/CaseStudiesOverview';
import CaseStudyDetail from './pages/CaseStudyDetail';
import FitnessOffer from './pages/FitnessOffer';
import Portfolio from './pages/Portfolio';
import InsightsHub from './pages/InsightsHub';
import GymLoseLeads from './pages/insights/GymLoseLeads';
import SpeedToLeadMath from './pages/insights/SpeedToLeadMath';
import BeautyOutcomes from './pages/insights/BeautyOutcomes';
import { LanguageProvider } from './context/LanguageContext';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <RouteSEO />
        <div className="min-h-screen bg-zinc-950 font-sans selection:bg-orange-500/30 selection:text-orange-200">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/insights" element={<InsightsHub />} />
              <Route path="/insights/5-reasons-gyms-lose-instagram-leads" element={<GymLoseLeads />} />
              <Route path="/insights/speed-to-lead-math" element={<SpeedToLeadMath />} />
              <Route path="/insights/beauty-outcomes-vs-treatments" element={<BeautyOutcomes />} />
              <Route path="/ai-lead-agent" element={<AiLeadAgent />} />
              <Route path="/beauty-clinic" element={<BeautyClinicOffer />} />
              <Route path="/content-shooting" element={<ContentShootingOffer />} />
              <Route path="/fitness-offer" element={<FitnessOffer />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/case-studies" element={<CaseStudiesOverview />} />
              <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/imprint" element={<Imprint />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;